import React, { Fragment, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import NotificationListItem from "../NotificationListItem";
import { Collection, CollectionStage, CollectionState } from "../../types";
import Button from "../Button";
import { Routes } from "../../constants";
import { useAuth } from "../../contexts/AuthContext";
import { useApi } from "../../contexts/ApiContext";

type Props = {
  collections: Collection[];
  stage?: CollectionStage;
  state?: CollectionState;
};

const DraftList = React.memo(({ collections, stage, state }: Props) => {
  const { push } = useHistory();
  const [listLength, setListLength] = useState(6);
  const [offset, setOffset] = useState(100)
  const [collecs, setCollecs] = useState<any[]>([])
  const filtered = collecs?.map((col) => {
    return { ...col, stage }
  })
  const { currentUserMetadata } = useAuth()
  const { retrieveCollectionsByType } = useApi()

  useEffect(() => {
    if (collections) {
      setCollecs([...collections])
    }
  }, [collections])


  const editCollection = (collection: Collection) => {
    push(`${Routes.MANAGE_DRAFT}/${collection.id}`);
  };



  const dateOrderedArray = filtered.sort(
    (a, b) => b.createdAt - a.createdAt
  );


  const loadMoreItems = async () => {
    setListLength(current => current + 6);
    const retrieveMoreCollections: any =
      await retrieveCollectionsByType({ creatorId: currentUserMetadata?.role === "admin" ? undefined : currentUserMetadata?.userId, offset: offset, limit: 10 }, 6);

    const moreCollections = retrieveMoreCollections ? retrieveMoreCollections : []
    setOffset(current => current + 10)
    setCollecs([...collecs, ...moreCollections])
  };

  return (
    <Fragment>
      <div className="grid sm:grid-cols-1 lg:grid-cols-2 sm:gap-4 lg:gap-8 w-full">

        {dateOrderedArray.length > 0
          && dateOrderedArray.map(
            (collection, idx) =>
              idx + 1 <= listLength && (
                <NotificationListItem
                  onClick={(collection: any) => editCollection(collection)}
                  key={collection.id}
                  collection={collection}
                  state={state}
                />
              )
          )}
        {dateOrderedArray?.length === 0 && (
          <div className="mb-6 mt-2">No collections at the moment.</div>
        )}
      </div>
      {dateOrderedArray?.length >= listLength && (
        <Button
          type="button"
          className="my-4 ml-auto mr-auto btn flex bg-gradient text-kyzzen-primary font-medium"
          onClick={loadMoreItems}
        >
          Show more
        </Button>
      )}
      <hr className="border border-gray-80 " />
    </Fragment>
  );
});

export default DraftList;
